const STORAGE_KEY = 'buffer:channel-refresh-attempts'
const REFRESH_UNSUCCESSFUL_THRESHOLD_MS = 5 * 60 * 1000 // 5 minutes

function isAttemptRecord(value: unknown): value is Record<string, number> {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false
  }

  return Object.values(value).every(
    (timestamp) => typeof timestamp === 'number' && Number.isFinite(timestamp),
  )
}

function readAttempts(): Record<string, number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}

    const parsed: unknown = JSON.parse(raw)
    return isAttemptRecord(parsed) ? parsed : {}
  } catch {
    return {}
  }
}

function writeAttempts(attempts: Record<string, number>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(attempts))
  } catch {
    // localStorage may be unavailable in some environments (SSR, private mode)
  }
}

export function recordRefreshAttempt(channelId: string): void {
  const attempts = readAttempts()
  attempts[channelId] = Date.now()
  writeAttempts(attempts)
}

export function clearRefreshAttempt(channelId: string): void {
  const attempts = readAttempts()
  if (channelId in attempts) {
    delete attempts[channelId]
    writeAttempts(attempts)
  }
}

/**
 * Returns true if a refresh was attempted for this channel more than
 * REFRESH_UNSUCCESSFUL_THRESHOLD_MS ago, meaning the refresh likely failed
 * (the status should have returned to ok by now if it succeeded).
 */
export function hasRefreshAttemptExpired(channelId: string): boolean {
  const attempts = readAttempts()
  const timestamp = attempts[channelId]
  if (!timestamp) return false
  return Date.now() - timestamp >= REFRESH_UNSUCCESSFUL_THRESHOLD_MS
}
